const UNCERTAIN_DELIVERY_STATUSES = new Set(["pending", "sending", "unknown"]);
const CONFIRMED_DELIVERY_STATUSES = new Set(["accepted", "sent", "delivered", "read"]);
const DELIVERY_STATUS_RANK: Record<string, number> = {
  pending: 0,
  sending: 1,
  unknown: 2,
  recorded: 3,
  simulated: 3,
  accepted: 4,
  sent: 4,
  failed: 5,
  delivered: 6,
  read: 7,
};

const normalizedStatus = (status?: string | null) => String(status || "").trim().toLowerCase();

export const isOutboundDeliveryUncertain = (status?: string | null) =>
  UNCERTAIN_DELIVERY_STATUSES.has(normalizedStatus(status));

export const getOutboundDeliveryFeedback = (
  status?: string | null
): "confirmed" | "failed" | "uncertain" => {
  const normalized = normalizedStatus(status);
  if (normalized === "failed") return "failed";
  if (CONFIRMED_DELIVERY_STATUSES.has(normalized)) return "confirmed";
  return "uncertain";
};

export const highestOutboundDeliveryStatus = (
  current?: string | null,
  incoming?: string | null
) => {
  const currentStatus = normalizedStatus(current);
  const incomingStatus = normalizedStatus(incoming);
  if (!currentStatus) return incomingStatus;
  if (!incomingStatus) return currentStatus;
  const currentRank = DELIVERY_STATUS_RANK[currentStatus] ?? -1;
  const incomingRank = DELIVERY_STATUS_RANK[incomingStatus] ?? -1;
  return incomingRank > currentRank ? incomingStatus : currentStatus;
};

export const shouldReconcileOutboundRequestError = (error: unknown) => {
  if (!error || typeof error !== "object") return true;
  const response = (error as { response?: { status?: unknown } }).response;
  if (!response) return true;
  const status = Number(response.status);
  return !Number.isFinite(status) || status >= 500;
};
